import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import WelcomeBanner from "./WelcomeBanner";
import IconButton from "@mui/material/IconButton";
import { LanguageOutlined } from "@mui/icons-material";
import * as styles from "../styles/HomeHeader.module.scss";
import { theme } from "../styles/theme";
import { useNavigate } from "react-router-dom";
import { Constants } from "../Constants";

const HomeHeader = () => {
  const navigate = useNavigate();

  return (
    <AppBar
      position="relative"
      sx={{
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
        boxShadow: 1
      }}
      className={styles.HomeHeader}
    >
      <Toolbar className={styles.toolbar}>
        <WelcomeBanner />
        <IconButton
          aria-label="Languages"
          className={styles.languageIcon}
          onClick={() => navigate(Constants.navigation.urls.language)}
          data-parentid="welcome-banner"
          data-id="language-link"
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
          }}
        >
          <LanguageOutlined fontSize="large" />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default HomeHeader;
